import { CreateElement } from '@src/vue'

import { Component } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'

import { Alignable } from '@src/mixins/alignable/alignable'

import './typography.sass'

@Component
export class H1 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography'].join(' ')

    return (
      <h1 class={styleClasses}>{this.$slots.default}</h1>
    )
  }
}

@Component
export class H2 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography'].join(' ')

    return (
      <h2 class={styleClasses}>{this.$slots.default}</h2>
    )
  }
}

@Component
export class H3 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography'].join(' ')

    return (
      <h3 class={styleClasses}>{this.$slots.default}</h3>
    )
  }
}

@Component
export class H4 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography'].join(' ')

    return (
      <h4 class={styleClasses}>{this.$slots.default}</h4>
    )
  }
}

@Component
export class H5 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography'].join(' ')

    return (
      <h5 class={styleClasses}>{this.$slots.default}</h5>
    )
  }
}

@Component
export class H6 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography'].join(' ')

    return (
      <h6 class={styleClasses}>{this.$slots.default}</h6>
    )
  }
}

@Component
export class Body1 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography', 'body-1'].join(' ')

    return (
      <div class={styleClasses}>{this.$slots.default}</div>
    )
  }
}

@Component
export class Body2 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography', 'body-2'].join(' ')

    return (
      <div class={styleClasses}>{this.$slots.default}</div>
    )
  }
}

@Component
export class Subtitle1 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography', 'subtitle-1'].join(' ')

    return (
      <p class={styleClasses}>{this.$slots.default}</p>
    )
  }
}

@Component
export class Subtitle2 extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography', 'subtitle-2'].join(' ')

    return (
      <p class={styleClasses}>{this.$slots.default}</p>
    )
  }
}

@Component
export class Caption extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography', 'caption'].join(' ')

    return (
      <div class={styleClasses}>{this.$slots.default}</div>
    )
  }
}

@Component
export class Overline extends Mixins<Alignable>(Alignable) {

  render (h: CreateElement) {
    let styleClasses = [...this.alignableStyles, 'typography', 'overline'].join(' ')

    return (
      <div class={styleClasses}>{this.$slots.default}</div>
    )
  }
}
